import { useEffect, useRef, useState } from "react";

const extractUrls = (arr) =>
    (arr || []).map((nav) => nav?.endemicAd?.buttonUrl || "").join(",");

export function useDetectEndemicAdChange(globalNav)
{
    const initialUrls = extractUrls(globalNav);
    const [forceRenderKey, setForceRenderKey] = useState(0);
    const prevUrlsRef = useRef(initialUrls);

    useEffect(() =>
    {
        const currentUrls = extractUrls(globalNav);
        const prevUrls = prevUrlsRef.current;

        if (currentUrls !== prevUrls)
        {
            prevUrlsRef.current = currentUrls;
            setForceRenderKey((k) => k + 1);
        }
    }, [globalNav]);

    return forceRenderKey;
}
